// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.column {
  float: left;
  width: 50%;
}

.row:after {
  content: "";
  display: table;
  clear: both;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+activities/ativity-filter/ativity-filter.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,UAAA;AACJ;;AAGE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AAAJ;;AAEE;EACE,kCAAA;AACJ","sourcesContent":[".column {\r\n    float: left;\r\n    width: 50%;\r\n   \r\n   \r\n  }\r\n  .row:after {\r\n    content: \"\";\r\n    display: table;\r\n    clear: both;\r\n  }\r\n  ::ng-deep .mat-mdc-text-field-wrapper {\r\n    background-color: white !important;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
